import { useRef } from 'react'
import { useTranslation } from '../../hooks'
import Input from '../../components/input'
import Button from '../../components/button'
import Alert from '../../components/alert'
import useLogin from './useLogin'
import './_login.scss'
import Spinner from '../../components/spinner/spinner'

const Login = () => {
  const { i18n } = useTranslation();
  const confirmationNumberField = useRef();
  const otpField = useRef();
  const {
    handleSubmit,
    isConfirmationNumberValid,
    isOtpValid,
    validate,
    defaultConfirmationNumber,
    otpMessage,
    errorMessage,
    retryCount,
    isOtpSending,
    isOtpValidating,
    isDeterminingValidLogin,
    handleGetOtp,
    haveExpiry
  } = useLogin(confirmationNumberField, otpField);

  const loginPageComp = isDeterminingValidLogin ? <Spinner /> : (
    <div className='login container container--narrow'>
      <h1 className="login__title">{i18n('cp_login')}</h1>
      <p className="login__copy">{i18n('cp_welcome')}</p>
      <form data-testid="form" className="login__form form card" onSubmit={handleSubmit} onInput={validate}>
        <Alert label={errorMessage} />
        <Input
          label={i18n('cp_confirmation_number')}
          placeholder={i18n('cp_enter_confirmation_number')}
          defaultValue={defaultConfirmationNumber}
          autoFocus={!defaultConfirmationNumber}
          ref={confirmationNumberField}
        />
        <Input
          label={i18n('cp_otp')}
          placeholder={i18n('cp_enter_otp')}
          autoFocus={!!defaultConfirmationNumber}
          ref={otpField}
        />
        <Button
          theme="outline"
          className="login__get-otp"
          disabled={!!retryCount || !isConfirmationNumberValid}
          onClick={handleGetOtp}
          loading={isOtpSending}
          testId="get-otp"
        >
          {retryCount ? `${i18n('cp_resend_otp')} ${retryCount}` : i18n('cp_get_otp')}
        </Button>
        {!!otpMessage && <p className='login__otp-sent-message'>{otpMessage}</p>}
        <Button
          disabled={!isConfirmationNumberValid || !isOtpValid}
          onClick={handleSubmit}
          loading={isOtpValidating}
          type="submit"
          testId="submit"
        >
          {i18n('cp_login')}
        </Button>
      </form>
    </div>
  )

  const decideScreenAction = () => {
    if(haveExpiry === 'true'){
       return <Spinner/>
    }
    return loginPageComp
  }
  return decideScreenAction(); 
}

export default Login
